import styled from 'styled-components'
import media from '../utils/media'

const QuestionContainer = styled.div`
  width: 100%;
  max-width: 680px;
  margin: 17px auto 0;
  position: relative;
  max-width: 680px;
  height: calc(100vh - 216px);
  max-height: 700px;
  overflow-y: auto;
  padding-top: 20px;
  ${media.tablet`
    max-width: 640px;
  `}
  ${media.mobileL`
    /* height: calc(100vh - 87px); */
    height: calc(100vh - 90px);
  `}
`

const Title = styled.div`
  text-align: center;
  margin-bottom: ${props =>
    props.marginBTitle ? props.marginBTitle : 28}px;
  p {
    color: ${props =>
      props.titleColor ? props.titleColor : '#414141'};
    font-size: ${props => (props.titleSize ? props.titleSize : 35)}px;
    /* line-height: 1.4; */
    line-height: 1;
    strong {
      font-weight: 600 !important;
      display: inline-block;
    }
  }
  ${media.mobileL`
    padding: 0 20%;
    margin-bottom: calc(${props =>
      props.marginBTitle ? props.marginBTitle : 18}px/2);
    p {
      font-size: calc(${props =>
        props.titleSize ? props.titleSize : 35}px/1.6);
    }
  `}
  ${media.mobileS`
    padding: 0 15%;
  `}
`

const BtnContainer = styled.div`
  width: 100%;
  position: relative;
  /* margin-top: 100px; */
  margin-bottom: 30px;
  max-width: 680px;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 20px;
  .styled-btn-action {
    display: flex;
    justify-content: flex-end;
    button {
      width: 323px;
      pointer-events: ${props => (props.unlocked ? 'auto' : 'none')};
      background-color: ${props =>
        props.unlocked ? '#ffae45' : '#b2b2b2'};
      text-align: left;
      padding: 15px 18px;
    }
  }
  ${media.mobileL`
    padding-top: 0;
    .styled-btn-action {
      background-color: #ffffff;
      border-top: 0.5px solid rgba(178, 178, 178, 0.5);
      padding: 17px 17px;
      margin: 0px auto 0px;
      width: 100%;
      display: block;
      position: fixed;
      /* bottom: -55px; */
      bottom: -15px;
      height: 87px;
      button {
        width: 100%;
        padding: 15px 18px;
      }
    }
  `}
  ${media.tablet`
    max-width: 640px;
  `}
`

const Icon = styled.span`
  position: absolute;
  z-index: 1;
  right: 0;
  margin: 13px 14px;
  transform: scale(0.7);
  svg {
    fill: #ffffff;
  }
  ${media.mobileL`
    margin: 13px 28px;
    /* top: -13px; */
    top: -54px;
  `}
`

export { QuestionContainer, Title, BtnContainer, Icon }
